import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/system";
import { checkIsShowSmallMenu } from "../../FormNavigation/utils";

const StyledFooter = styled("div")(({ theme, smallMenu }) => ({
  width: "100%",
  zIndex: 999,
  display: "flex",
  flexDirection: "column-reverse",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "1.5rem",
  background: "#FFFFFF",
  padding: "3rem 0.9375rem 2rem 0.9375rem",
  position: "fixed",
  bottom: "0px",
  right: "0px",
  margin: "0px",
  boxSizing: "border-box",
  "& .back-link": {
    "& .linkContainerBtn": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
      textAlign: "center",
      padding: "10px 40px",
      borderRadius: "6.25rem",
      background: "#FFF",
      color: "#000",
      fontWeight: 500,
      lineHeight: "1.5rem",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
        minWidth: "auto",
        fontSize: "1.125rem"
      },
      "&:hover": {
        "& svg": {
          fill: "var(--Color-Text-Primary-On-Light)"
        }
      },
      "& svg": {
        display: "none",
        [theme.breakpoints.up("sm")]: {
          display: "block"
        }
      }
    }
  },
  "& .footerCTA": {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto"
    },
    button: {
      "& svg": {
        width: "17px",
        height: "17px",
        display: "none",
        "&.btnLoader": {
          display: "block"
        },
        [theme.breakpoints.up("sm")]: {
          display: "block"
        }
      }
    }
  },
  button: {
    width: "100%",
    minWidth: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      minWidth: "auto"
    }
  },
  [theme.breakpoints.only("xs")]: {
    padding: "0.6rem 1rem 0.1rem",
    width: "100%",
    maxWidth: "100%",
    boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.05)",
    gap: "0.5rem",
    position: "block"
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    padding: "1.5rem 5.125rem",
    alignItems: "flex-end"
  }
}));
export const Footer = ({ children, extraClasses, dataTestId, hideSaveClose = false }) => {
  const { pathname } = useLocation();

  return (
    <StyledFooter
      data-testid={dataTestId}
      smallMenu={checkIsShowSmallMenu(pathname)}
      className={extraClasses}
    >
      {children}
    </StyledFooter>
  );
};

Footer.propTypes = {
  /** Child elements to render inside the footer */
  children: PropTypes.node.isRequired,
  /** Additional CSS classes to apply to the footer */
  extraClasses: PropTypes.string,
  /** ID for testing purposes */
  dataTestId: PropTypes.string,
  /** Flag to control save/close button visibility */
  hideSaveClose: PropTypes.bool
};
